import { __rest } from "tslib";
import React, { useState } from 'react';
import SelectInput from '../selectInput';
import ContactModal from '../modal';
import useContactItemEffect from '@web-common/components/UI/SiriusContact/useContactItemEffect';
import { transMailContactModel2ContactItem } from '@web-common/utils/contact_util';
import { extractEmailsFromText } from '@web-mail-write/components/Selector/helper';
import { api, apis } from 'api';
import { transContactModel2ContactItem } from '@web-common/components/util/contact';
const mailApi = api.requireLogicalApi(apis.mailApiImpl);
const contactApi = api.requireLogicalApi(apis.contactApiImpl);
const ContactScheduleModal = props => {
    const { onChange, modalProps, defaultSelectList = [], recent100, field, source, firstPositionNotDelEmail, noRelateEnterprise = false, accountRootKey, useMultiAccount } = props, rest = __rest(props, ["onChange", "modalProps", "defaultSelectList", "recent100", "field", "source", "firstPositionNotDelEmail", "noRelateEnterprise", "accountRootKey", "useMultiAccount"]);
    const [selectList, setSelectList] = useState(defaultSelectList);
    const [visible, setVisible] = useState(false);
    const handleChange = (item) => {
        setSelectList(item);
        onChange && onChange(item);
    };
    useContactItemEffect(defaultSelectList, () => {
        setSelectList(defaultSelectList);
    });
    const handlePaste = async (clipboardData) => {
        const extractEmails = extractEmailsFromText(clipboardData);
        if ((extractEmails === null || extractEmails === void 0 ? void 0 : extractEmails.length) === 0) {
            return;
        }
        const oldEmails = selectList.map(item => item.email);
        const newEmails = extractEmails.map(item => item.mail);
        const emails = [...new Set([...oldEmails, ...newEmails])];
        const result = await contactApi.doGetContactByEmailFilter({ emails });
        const result1 = await mailApi.getContractItemByEmail(emails, '');
        const contactItemList = [];
        emails.forEach((email, index) => {
            if (email) {
                if (result[email]) {
                    contactItemList.push(transContactModel2ContactItem(result[email]));
                }
                else {
                    if (result1[index]) {
                        contactItemList.push(transMailContactModel2ContactItem(result1[index]));
                    }
                }
            }
        });
        if (contactItemList && contactItemList.length) {
            handleChange(contactItemList);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(SelectInput, Object.assign({}, rest, { useEdm: rest.useEdm, firstPositionNotDelEmail: firstPositionNotDelEmail, isIM: false, showSuffix: !rest.disabled && !rest.hiddenSuffix, showNoData: rest.showNoData, defaultSelectList: selectList, recent100: recent100, field: field, source: source, onClickSuffix: () => {
                setVisible(true);
            }, _account: accountRootKey, changeHandle: handleChange, noRelateEnterprise: noRelateEnterprise, onPaste: (e) => {
                const { clipboardData } = e;
                const value = clipboardData.getData('text');
                handlePaste(value);
                e.preventDefault();
            } })),
        React.createElement(ContactModal, { includeSelf: rest.includeSelf, accountRootKey: accountRootKey, firstPositionNotDelEmail: firstPositionNotDelEmail, defaultSelectList: selectList, isIM: false, showAddOrgBtn: true, showAddTeamBtn: true, showAddPersonalBtn: true, visible: visible, onCancel: () => {
                setVisible(false);
            }, onSure: item => {
                setVisible(false);
                handleChange(item);
            }, modalProps: modalProps, noRelateEnterprise: noRelateEnterprise, type: rest.type, useEdm: rest.useEdm, useMultiAccount: useMultiAccount })));
};
export default ContactScheduleModal;
